<template>
	<div>
		<div class="message-log-container" v-if="isHaveMessage">
			<div class="message-card"
			:class="{
				'sent-message': isSent(item),
				'received-message': !isSent(item)
			}"
			v-for="item in listMessage"
			:key="item._id">
				<div class="message-card-header">
					<span class="message-sender">{{item.source_name}}</span>
					<br>
					<span class="message-timestamp">{{formatDate(moment, item.created_at, 'DD-MM-YYYY HH:mm')}}</span>
				</div>
				<hr>
				<div class="message-card-body">
					{{ item.content }}
				</div>
			</div>
		</div>
		<div class="message-log-container-empty d-flex justify-content-center" v-if="!isHaveMessage">
			<div class="my-auto align-items-center">
				Belum ada pesan yang disimpan
			</div>
		</div>
	</div>
</template>

<script>
import { formatDate } from '@/lib/helper';

export default {
	name: 'TicketMessage',
	props: {
		listMessage: {
			type: Array,
			default: () => [],
		},
		userData: {
			type: Object,
			default: () => {},
		},
	},
	methods: {
		formatDate,
		isSent(item) {
			return item.created_by === this.user._id;
		},
	},
	computed: {
		isHaveMessage() {
			return this.listMessage.length > 0;
		},
		user() {
			return this.userData;
		},
	},
};
</script>

<style>
	.message-log-container {
		height: 500px; /* Set a maximum height for the container */
		overflow-y: auto; /* Enable vertical scrolling */
		padding: 16px; /* Optional padding for better appearance */
		background-color: #cfe8fd;
		display: flex;
		flex-direction: column;
		align-items: flex-start;
		border-radius: 8px;
	}

	.message-log-container-empty {
		height: 500px; /* Set a maximum height for the container */
		overflow-y: auto; /* Enable vertical scrolling */
		padding: 16px; /* Optional padding for better appearance */
		background-color: #cfe8fd;
	}

	.message-card {
		background-color: #ffffff;
		padding: 10px;
		margin-bottom: 10px;
		border-radius: 8px;
		width: 50%;
	}

	.message-card-header {
		margin-bottom: 5px;
	}

	.message-sender {
		font-weight: bold;
	}

	.message-timestamp {
		color: #666;
		font-size: 12px;
	}

	.message-card-body {
		font-size: 14px;
	}
	.ticket-info {
		margin-bottom: 20px;
	}

	.info-row {
		margin-bottom: 8px;
	}

	.sent-message {
		background-color: #ffffff;
		align-self: flex-end;
	}

	.received-message {
		background-color: #ffffff;
		align-self: flex-start;
	}
</style>
